/* eslint-disable import/prefer-default-export */
import { atob as zhatob } from './base64';

/**
  * base64格式转二进制对象
  * @param base64 base64格式的string
  * @param contentType 内容
  * @param sliceSize 截取大小
  */
export function base64ToBlob(
  base64: string,
  contentType = '',
  sliceSize = 512,
  zh = false,
): Blob {
  const byteCharacters = (zh ? zhatob : atob)(base64);
  const byteArrays = [];
  let offset = 0;
  while (offset < byteCharacters.length) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    byteArrays.push(new Uint8Array(Array.from(slice, c => c.charCodeAt(0))));
    offset += sliceSize;
  }
  const blob = new Blob(byteArrays, {
    type: contentType,
  });
  return blob;
}

// TODO: export const blobToBase64 = (b: Blob): string => {
//
// };
